import { gql } from "graphql-tag"

const content = gql`
  type Query {
    getContentAuthors: [ContentAuthor]
  }
`

export default content
